import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { saveCustomerJourneyCookie } from "@cinch-labs/customer-journey-cookies";
import { Heading } from "@cinch-labs/design-system";
import { useViewport } from "@cinch-labs/shared-util";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import { Head, StoryblokRenderer } from "@cinch-nx/landing-ui-shared";
import { ModalChat, TrustpilotReviews, Wrapper } from "@cinch-nx/shared-ui";
import { OurCommitmentCarousel, RecentAndRecommendedVehicles, ShopByShape, USPContainer, WeBuyAnyCar } from "./components";
import { storyblokComponents } from "./data/storyblok-renderer-map";
import styles from "./homepage.module.css";
import homePage from "./locale/index";
export var LandingFeatureHomePage = function(param) {
    var preview = param.preview, vehiclesData = param.vehiclesData, trustpilotData = param.trustpilotData, story = param.story, showPersonalisedComponents = param.showPersonalisedComponents, recentlyViewedListings = param.recentlyViewedListings, similarListings = param.similarListings, flags = param.flags;
    story = useStoryblokState({
        story: story,
        enableBridge: preview
    });
    var ourCommitmentSlides = homePage.ourCommitmentSlides, wbac = homePage.wbac, trustpilotReviews = homePage.trustpilotReviews, seo = homePage.seo;
    var ref;
    var isHomeHeroExperimentEnabled = (ref = flags === null || flags === void 0 ? void 0 : flags.showHomepageHeroV2) !== null && ref !== void 0 ? ref : false;
    saveCustomerJourneyCookie();
    var vw = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    }).vw;
    var isMobile = vw < 600;
    var isProd = process.env["STAGE_NAME"] === "production";
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, _object_spread_props(_object_spread({}, story), {
                fallbackTitle: seo.title,
                fallbackDescription: seo.description
            })),
            !isHomeHeroExperimentEnabled && /*#__PURE__*/ _jsx(StoryblokRenderer, {
                block: story.content.hero,
                components: storyblokComponents,
                props: {
                    makes: vehiclesData.makes,
                    totalStock: vehiclesData.totalStock,
                    starRating: trustpilotData.stars,
                    starRatingLabel: trustpilotData.starRatingLabel
                }
            }),
            isHomeHeroExperimentEnabled && !!story.content.herov2 && /*#__PURE__*/ _jsx(StoryblokRenderer, {
                block: story.content.herov2,
                components: storyblokComponents,
                props: {
                    makes: vehiclesData.makes,
                    totalStock: vehiclesData.totalStock,
                    starRating: trustpilotData.stars,
                    starRatingLabel: trustpilotData.starRatingLabel,
                    numberOfReviews: trustpilotData.total
                }
            }),
            isHomeHeroExperimentEnabled && story.content.usp ? /*#__PURE__*/ _jsx(USPContainer, {
                slides: story.content.usp
            }) : null,
            showPersonalisedComponents ? /*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        element: "h2",
                        className: styles["heading"],
                        children: "Welcome back"
                    }),
                    /*#__PURE__*/ _jsx(RecentAndRecommendedVehicles, {
                        recentlyViewedListings: recentlyViewedListings !== null && recentlyViewedListings !== void 0 ? recentlyViewedListings : [],
                        similarListings: similarListings !== null && similarListings !== void 0 ? similarListings : []
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles["valuePropsCardsContainer"],
                        children: /*#__PURE__*/ _jsx(StoryblokRenderer, {
                            block: story.content.personalised[0].valuePropositions,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ _jsx(StoryblokRenderer, {
                        block: story.content.personalised[0].helpMeChoose,
                        components: storyblokComponents
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(ShopByShape, {
                count: vehiclesData.carTypes
            }),
            !showPersonalisedComponents ? /*#__PURE__*/ _jsx(StoryblokRenderer, {
                block: story.content.whyCinch,
                components: storyblokComponents
            }) : null,
            /*#__PURE__*/ _jsx(StoryblokRenderer, {
                block: story.content.partEx,
                components: storyblokComponents
            }),
            /*#__PURE__*/ _jsx(TrustpilotReviews, {
                title: trustpilotReviews.title,
                starRatingLabel: trustpilotData.starRatingLabel,
                numberOfReviews: trustpilotData.total,
                reviews: trustpilotData.reviews
            }),
            !showPersonalisedComponents ? /*#__PURE__*/ _jsx(OurCommitmentCarousel, _object_spread({}, ourCommitmentSlides)) : null,
            /*#__PURE__*/ _jsx(WeBuyAnyCar, _object_spread({}, wbac)),
            isMobile ? /*#__PURE__*/ _jsx(ModalChat, {}) : null,
            isProd ? /*#__PURE__*/ _jsx("img", {
                alt: "ZeroFox",
                className: styles["zeroFox"],
                src: "https://d21y75miwcfqoq.cloudfront.net/786a6533"
            }) : null
        ]
    });
};
export default LandingFeatureHomePage;
